import axios from "axios";
import { API_PATH } from "../config";

const instance = axios.create();

instance.interceptors.request.use(
  async (request) => {
    request.baseURL = API_PATH;

    return request;
  },
  (err) => {
    // Error from Request will be handled here
    console.log("handle error", err);
    return Promise.reject(err);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res.data;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

export default instance;
